// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__Gw2KT"};